import React from 'react';

const Ellipses = (): JSX.Element => (
  <li>
    <span className="pagination-ellipsis">&hellip;</span>
  </li>
);

export default Ellipses;
